import cx from 'classnames';

import {
  MessageWrapper
} from '../styles/styles.js';

const StatusMessage = ({ inline, text }) => {
  return (
    <MessageWrapper
      className={cx({'relative': inline })}>
        {text}
    </MessageWrapper>
  );
}
export default StatusMessage;
